<template>
    <div>
        <Sidebar />
        <ImpersonateBanner />
        <div class="2xl:pl-72 h-screen overflow-auto bg-neutral-100 dark:bg-gray-800">
            <Header />
            <main>
                <div>
                    <UserBirthdayModal />
                    
                    <!-- Your content -->
                    <slot />
                </div>
            </main>
        </div>
        <RequestLog />
    </div>
</template>

<script setup>
import Header from "@/components/layouts/Header"
import ImpersonateBanner from "@/components/layouts/ImpersonateBanner"
import Sidebar from "@/components/layouts/Sidebar"
import {useWebsocketStore} from "@/store/websockets"
import {useAuthStore} from "~/store/auth"

const authStore = useAuthStore()

watch(() => authStore.userData?.id, (newValue, oldValue) => {
    if (newValue && newValue !== oldValue) {
        useWebsocketStore().init(newValue)
    }
}, {immediate: true})

useHead({
    bodyAttrs: {
        class: 'h-full bg-gray-50'
    },
    htmlAttrs: {
        class: 'h-full'
    }
})

// Comment out to deactivate the help pages
useHelpPage().listenForHelp()
</script>
